<template>
  <div class="live_item">
    <div v-if="msg.menus.length&&msg.menus[0].title">
      <div class="video_special" @click="$downapppop.open">
        <div class="video_cover">
          <img v-lazy="msg.menus[0].v_cover || msg.menus[0].v_img" alt />
          <div class="play_btn">
            <img :src="require('@/assets/images/icon-play-btn@2x.png')" alt />
          </div>
        </div>
        <div class="video_special_detail">
          <div>
            <h4>{{msg.menus[0].v_title}}</h4>
            <p>{{msg.menus[0].video_desc}}</p>
          </div>
          <dl>
            <dt>
              <img :src="require('@/assets/images/icon-video @2x.png')" alt />
            </dt>
            <dd>查看视频</dd>
          </dl>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="thumbnail">
        <div
          ref="imgItem"
          :isrc="item.video_img"
          v-for="(item,i) in msg.menus"
          class="img-item"
          :class="{'img-item-one':msg.image.length==0}"
          :key="i"
        >
          <div class="vedio_img" v-if="item.video">
            <span class="vedio_image">
              <img class="vedio_image_img" :src="item.video_img" alt />
              <!-- todo -->
              <p @click="clickPlay(item.video)">
                <img
                  class="vedio_play"
                  src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png"
                />
                <span class="vedio_time">
                  <img
                    class="vedio_time_icon"
                    src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png"
                  />
                  <i>{{item.video_len}}s</i>
                </span>
              </p>
            </span>
          </div>
        </div>
        <div
          ref="imgItem"
          :isrc="item"
          class="img-item"
          v-if="msg.image.length"
          v-for="(item,index) in msg.image"
          :class="{'img-item-one':msg.image.length==1 && msg.menus==0}"
          :key="'index'+index"
        >
          <img class="live_img" @load="$previewRefresh" :preview="randomStr" v-lazy="item" alt="图片" />
        </div>
        <div
          ref="imgItem"
          :isrc="item"
          class="img-item"
          v-else-if="msg.image_thumb.length"
          v-for="(item,o) in msg.image_thumb"
          :class="{'img-item-one':msg.image_thumb.length==1 && msg.menus==0}"
          :key="'o'+o"
        >
          <img class="live_img" @load="$previewRefresh" :preview="randomStr" v-lazy="item" alt="图片" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "imageViewpoint",
  props: {
    msg: Object
  },
  data() {
    return {
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },

  created() {},
  mounted() {
    // 设置缩略图的样式。
    if (this.$refs.imgItem && this.$refs.imgItem.length > 0) {
      this.$refs.imgItem.forEach(element => {
        let eWidth = element.offsetWidth;
        let isOneImg = element.classList.contains("img-item-one");
        element.style.height = eWidth + "px";
        let isrc = element.getAttribute("isrc");
        let live_img = element.querySelectorAll("img.live_img")[0];
        let video_img = element.querySelectorAll(".vedio_image_img")[0];
        if (live_img && !isOneImg) {
          live_img.style.opacity = "0";
          element.style.cssText =
            "height:" +
            eWidth +
            "px;background-image:url(" +
            isrc +
            ");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;";
        } else if(video_img && !isOneImg){
            video_img.style.opacity = "0";
          element.style.cssText =
            "height:" +
            eWidth +
            "px;background-image:url(" +
            isrc +
            ");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;";
        }
        if (isOneImg) {
          //但张图片或视频的时候
          let _img = new Image();
          _img.onload = function() {
            let maxHeight = 230;
            let maxWidth = 230;
            let tempWidth = 0;
            let tempHeight = 0;
            if (_img.width > 0 && _img.height > 0) {
              if (_img.width / _img.height >= 1) {
                //横向图
                var o_height = Math.ceil(_img.height / (_img.width / maxWidth));
                o_height = o_height > 30 ? o_height : 30;
                tempWidth = maxWidth;
                tempHeight = o_height;
              } else {
                //竖向图
                var o_width = Math.ceil(_img.width / (_img.height / maxHeight));
                o_width = o_width > 30 ? o_width : 30;
                tempHeight = maxHeight;
                tempWidth = o_width;
              }
              element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;`;
            }
          };
          _img.src = isrc;
        }
      });
    }
  },
  methods: {
    clickPlay(src) {
      this.$videoplay.open(src);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.live_item .thumbnail .img-item-one {
  width: 231px;
  height: 174px;
}
</style>